<div class="container-fluid pb-4 mb-4">
  <pos-app-spinner [show]="loading$ | async"></pos-app-spinner>

  <h3 class="text-center py-3 arb-large-heading">CUSTOMER VEHICLE PROMOTIONS</h3>
  <div class="d-flex justify-content-end">
    <button *ngIf="managePromotion" class="btn" (click)="showManagePromotion()">Manage Vehicle Promotion</button>
    <button *ngIf="managePromotion" class="btn" (click)="showVehicleSearchForPromotion()">Search Vehicle Promotion by Rego</button>
  </div>
  <div *ngIf="!managePromotion" class="row d-flex justify-content-center align-items-center">
    <div class="col-2 text-right">
      <label>VEHICLE SEARCH:</label>
    </div>
    <div class="col-4">
      <pos-app-lib-customer-vehicle-search
        (newCustomerVehiclePromotion)="customerVehiclePromotion($event)"
        (showResultText)="showResultText($event)"
      ></pos-app-lib-customer-vehicle-search>
    </div>
  </div>
  <div class="row d-flex justify-content-center align-items-center">
    <div class="row d-flex justify-content-center align-items-center" *ngIf="managePromotion">
      <div class="col-2 text-right text-uppercase">
        <label>Select Promotion:</label>
      </div>
      <div class="col-6 row d-flex justify-content-center align-items-center">
        <ng-select class="col-7" [(ngModel)]="currentIndex" (change)="setIndex(currentIndex)" [searchable]="true" placeholder="Select Promotion">
          <ng-option *ngFor="let promotion of customerVehiclePromotionList; let i = index" [value]="i">
            {{ promotion.promotionCode }} - {{ promotion.promotionName }}
          </ng-option>
        </ng-select>
        <div class="col-4">
          <button *ngIf="managePromotion" class="btn btn-secondary" (click)="addNewPromotion()">Add New Promotion</button>
        </div>
      </div>
    </div>
  </div>
  <div>
    <form *ngIf="promotionsDetailForm" class="row d-flex justify-content-center align-items-center" [formGroup]="customerVehiclePromotionsForm">
      <div *ngIf="customerVehicleDetails || isNewPromotion">
        <div class="col-sm-12 text-center my-2 mb-2 arb-medium-heading">Vehicle Promotion Details</div>
        <div class="border px-2">
          <div *ngIf="!managePromotion" class="border-bottom my-2">
            <div class="border-bottom w-50 my-1"><mat-icon>person</mat-icon></div>
            <div class="d-flex justify-content-center align-items-center row flex-wrap">
              <div class="col-sm-6 my-2 form-group row flex-wrap">
                <label class="col-sm-4 my-2" for="customerName">CUSTOMER NAME</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" [readonly]="true" [value]="customerVehicleDetails.customerName" />
                </div>
              </div>
              <div class="col-sm-6 my-2 form-group row flex-wrap">
                <label class="col-sm-4 my-2" for="customerNumber">CUSTOMER NUMBER</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" [readonly]="true" [value]="customerVehicleDetails.customerNumber" />
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center align-items-center row flex-wrap">
              <div class="col-sm-6 my-2 form-group row flex-wrap">
                <label class="col-sm-4 my-2" for="vehicle">VEHICLE</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" [readonly]="true" [value]="customerVehicleDetails.vehicleShortDescription" />
                </div>
              </div>
              <div class="col-sm-6 my-2 form-group row flex-wrap">
                <label class="col-sm-4 my-2" for="color">VEHICLE COLOR</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" [readonly]="true" [value]="customerVehicleDetails.vehicleColour" />
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-start border-bottom w-50 mb-2 pb-2">
            <div class="">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f">
                <path
                  d="M260-320q25 0 42.5-17.5T320-380q0-25-17.5-42.5T260-440q-25 0-42.5 17.5T200-380q0 25 17.5 42.5T260-320Zm360 0q20 0 36-12t21-31q-20-4-38-13.5T606-401l-25-25q-10 8-15.5 20t-5.5 26q0 25 17.5 42.5T620-320Zm-460 40v-200 200Zm40 80v40q0 17-11.5 28.5T160-120h-40q-17 0-28.5-11.5T80-160v-320l84-240q6-18 21.5-29t34.5-11h140v55q0 6 .5 12.5T362-680H234l-42 120h255l80 80H160v200h560v-81q22-2 42.5-11t37.5-25v237q0 17-11.5 28.5T760-120h-40q-17 0-28.5-11.5T680-160v-40H200Zm400-520q17 0 28.5-11.5T640-760q0-17-11.5-28.5T600-800q-17 0-28.5 11.5T560-760q0 17 11.5 28.5T600-720Zm62 262L458-662q-8-8-13-19.5t-5-23.5v-155q0-25 17.5-42.5T500-920h155q12 0 23.5 5t19.5 13l204 204q17 17 17 42.5T902-613L747-458q-17 17-42.5 17T662-458Zm43-70 127-127-185-185H520v127l185 185Zm-29-156Z"
                />
              </svg>
            </div>

            <div class="">
              <button *ngIf="allowEdit && !isNewPromotion" class="btn btn-secondary" (click)="addNewPromotionForVehicle()">Add New Promotion</button>
            </div>
          </div>
          <div *ngIf="!customerVehiclePromotionList.length" class="text-center arb-medium-heading py-4">No promotion found</div>
          <div *ngIf="(customerVehiclePromotionList?.length > 0 && !isNewPromotion) || isNewPromotion">
            <div class="d-flex justify-content-center align-items-center row flex-wrap">
              <div class="col-sm-6 my-2 form-group row flex-wrap">
                <label class="col-sm-4 my-2 text-uppercase" for="promotionName">Promotion Name</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" [readonly]="!isNewPromotion" formControlName="promotionName" />
                </div>
              </div>
              <div class="col-sm-6 my-2 form-group row">
                <label class="col-sm-4 my-2 text-uppercase" for="promotion">Promotion</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" [readonly]="!isNewPromotion" formControlName="promotionShortDescription" />
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center align-items-start row flex-wrap">
              <div class="col-sm-6 my-2 form-group row flex-wrap">
                <label class="col-sm-4 my-2 text-uppercase" for="promotionCode">Promotion Code</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" [readonly]="!isNewPromotion" formControlName="promotionCode" />
                </div>
              </div>
              <div class="col-sm-6 my-2 form-group row">
                <label *ngIf="customerVehiclePromotionsForm?.controls.startingOdometer.value" class="col-sm-4 my-2 text-uppercase" for="promotion"
                  >Odometer</label
                >
                <div *ngIf="customerVehiclePromotionsForm?.controls.startingOdometer.value" class="col-sm-8">
                  <input type="text" class="form-control" [readonly]="!allowEdit" formControlName="startingOdometer" autofocus />
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-center align-items-center row flex-wrap">
              <div class="col-sm-6 my-2 form-group row flex-wrap">
                <label class="col-sm-4 my-2 text-uppercase" for="effectiveDate">Effective Date</label>
                <div class="col-sm-8">
                  <div class="input-group">
                    <input
                      class="form-control"
                      name="d1"
                      ngbDatepicker
                      #d1="ngbDatepicker"
                      [placement]="'bottom'"
                      container="body"
                      formControlName="startingDate"
                      autocomplete="off"
                      [style.pointer-events]="allowEdit ? 'auto' : null"
                      [style.background-color]="allowEdit ? '#fff' : null"
                      [readonly]="true"
                      (click)="allowEdit && d1.toggle()"
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-secondary calendar text-white btn-picker"
                        style="height: 40px"
                        [disabled]="!allowEdit"
                        (click)="d1.toggle()"
                        type="button"
                      ></button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 my-2 form-group row">
                <label class="col-sm-4 my-2 text-uppercase" for="expiryDate">Expiry Date</label>
                <div class="col-sm-8">
                  <div class="input-group">
                    <input
                      class="form-control"
                      name="d2"
                      ngbDatepicker
                      #d2="ngbDatepicker"
                      [placement]="'bottom'"
                      container="body"
                      formControlName="endingDate"
                      autocomplete="off"
                      [style.pointer-events]="allowEdit ? 'auto' : null"
                      [style.background-color]="allowEdit ? '#fff' : null"
                      [readonly]="true"
                      (click)="allowEdit && d2.toggle()"
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-secondary calendar text-white btn-picker"
                        style="height: 40px"
                        (click)="d2.toggle()"
                        type="button"
                        [disabled]="!allowEdit"
                      ></button>
                    </div>
                  </div>
                  <!-- <input type="text" class="form-control" [readonly]="!allowEdit" formControlName="expiryDate" /> -->
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center align-items-center row flex-wrap">
              <div class="col-sm-12 my-2 form-group row flex-wrap">
                <label class="col-sm-2 my-2 text-uppercase" for="promotionTerms">Promotion Terms</label>
                <div class="col-sm-10">
                  <textarea class="form-control" [readonly]="!isNewPromotion" formControlName="promotionTerms" rows="6"></textarea>
                </div>
              </div>
            </div>
            <div *ngIf="!managePromotion">
              <div class="border-bottom w-50 my-1"><mat-icon>event_note</mat-icon></div>

              <div class="d-flex justify-content-center align-items-center row flex-wrap">
                <div class="col-sm-4 my-2 form-group row flex-wrap">
                  <label class="col-sm-6 my-2 text-uppercase" for="site">Last changed site</label>
                  <div class="col-sm-6">
                    <input type="text" class="form-control" [readonly]="true" formControlName="lastChangedBySiteCode" />
                  </div>
                </div>
                <div class="col-sm-4 my-2 form-group row flex-wrap">
                  <label class="col-sm-6 my-2 text-uppercase" for="lastChangedByUser">Last changed by</label>
                  <div class="col-sm-6">
                    <input type="text" class="form-control" [readonly]="true" formControlName="lastChangedByUser" />
                  </div>
                </div>
                <div class="col-sm-4 my-2 form-group row flex-wrap">
                  <label class="col-sm-6 my-2 text-uppercase" for="lastChangedDate">Last changed date</label>
                  <div class="col-sm-6">
                    <input type="text" class="form-control" [readonly]="true" formControlName="lastChangedDate" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="customerVehiclePromotionList?.length > 1 && !isNewPromotion && formValid"
            class="d-flex justify-content-center align-items-center border-bottom my-1"
          >
            <nav aria-label="Promotion pagination">
              <ul class="pagination">
                <li class="page-item" [class.disabled]="currentIndex === 0">
                  <button class="page-link" (click)="changeIndex(-1)" [disabled]="currentIndex === 0">Previous</button>
                </li>
                <li class="page-item" *ngFor="let item of customerVehiclePromotionList; let i = index" [class.active]="i === currentIndex">
                  <button class="page-link" (click)="setIndex(i)">{{ i }}</button>
                </li>
                <li class="page-item" [class.disabled]="currentIndex === customerVehiclePromotionList.length - 1">
                  <button class="page-link" (click)="changeIndex(1)" [disabled]="currentIndex === customerVehiclePromotionList.length - 1">
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div *ngIf="allowEdit || isNewPromotion" class="modal-footer">
          <button *ngIf="formValid" type="button" class="btn btn-secondary text-uppercase" (click)="resetInitialFormValue()">Reset</button>
          <button type="button" class="btn btn-cancel text-uppercase" (click)="onClose()">Cancel</button>
          <button type="button" class="btn text-uppercase" [disabled]="!customerVehiclePromotionsForm.valid || !formValid" (click)="onSave()">
            Save
          </button>
        </div>
      </div>
      <div *ngIf="!customerVehicleDetails && isShowText && !isNewPromotion" class="text-center arb-medium-heading py-4">Rego not found</div>
    </form>
  </div>
</div>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="modal-title text-uppercase">Add promotion to vehicle</h3>
  </div>
  <div class="modal-body">
      <div class="d-flex flex-wrap justify-content-center align-items-start">
        <div class="w-80 my-2 d-flex align-items-center">
          <label class="text-uppercase mb-0 mx-2" for="promotionName" style="flex: 0 0 150px; width: 150px">Promotion Name</label>
      </div>
          <div class="flex-fill mb-2" style="margin-left: 10px;">
        <ng-select
          *ngIf="isAddingPromotionForVehicle"
          [(ngModel)]="currentIndexForVehicle"
          (change)="setIndexForPromotionToAdd(currentIndexForVehicle)"
          [searchable]="true"
          placeholder="Select Promotion"
        >
          <ng-option *ngFor="let promotion of vehiclePromotionList; let i = index" [value]="i">
            {{ promotion.promotionCode }} - {{ promotion.promotionName }}
          </ng-option>
        </ng-select>
      </div>
    </div>
    <div *ngIf="vehiclePromotionList && currentIndexForVehicle >= 0" class="border p-2">
      <div class="d-flex flex-wrap justify-content-center align-items-start">
        <div class="w-50 my-2 d-flex align-items-center">
          <label class="text-uppercase mb-0 mx-2" for="promotionName" style="flex: 0 0 150px; width: 150px">Promotion Name</label>
          <div class="flex-fill">
            <input
              type="text"
              class="form-control"
              [readonly]="!isNewPromotion"
              [value]="vehiclePromotionList[currentIndexForVehicle]?.promotionName ?? ''"
            />
          </div>
        </div>

        <div class="w-50 my-2 d-flex align-items-center">
          <label class="text-uppercase mb-0 mx-2" for="promotion" style="flex: 0 0 150px; width: 150px; padding-left: 10px">Promotion</label>
          <div class="flex-fill">
            <input
              type="text"
              class="form-control"
              [readonly]="!isNewPromotion"
              [value]="vehiclePromotionList[currentIndexForVehicle]?.promotionShortDescription ?? ''"
            />
          </div>
        </div>
      </div>

      <div class="d-flex flex-wrap justify-content-start align-items-start">
        <div class="w-50 my-2 d-flex align-items-center">
          <label class="text-uppercase mb-0 mx-2" for="promotionCode" style="flex: 0 0 150px; width: 150px">Promotion Code</label>
          <div class="flex-fill">
            <input
              type="text"
              class="form-control"
              [readonly]="!isNewPromotion"
              [value]="vehiclePromotionList[currentIndexForVehicle]?.promotionCode ?? ''"
            />
          </div>
        </div>

        <div class="w-50 my-2 d-flex align-items-center">
          <ng-container *ngIf="customerVehiclePromotionsForm?.controls.startingOdometer.value">
            <label class="text-uppercase mb-0 mx-2" for="promotion" style="flex: 0 0 150px; width: 150px">Odometer</label>
            <div class="flex-fill">
              <input
                type="text"
                class="form-control"
                [readonly]="!allowEdit"
                [value]="vehiclePromotionList[currentIndexForVehicle]?.startingOdometer ?? ''"
              />
            </div>
          </ng-container>
        </div>
      </div>

      <div class="d-flex flex-wrap justify-content-center align-items-start">
        <div class="w-50 my-2 d-flex align-items-center">
          <label class="text-uppercase mb-0 mx-2" for="effectiveDate" style="flex: 0 0 150px; width: 150px">Effective Date</label>
          <div class="flex-fill">
            <div class="input-group">
              <input class="form-control" [value]="vehiclePromotionList[currentIndexForVehicle]?.effectiveDate ?? ''" [readonly]="true" />
            </div>
          </div>
        </div>

        <div class="w-50 my-2 d-flex align-items-center">
          <label class="text-uppercase mb-0 mx-2" for="expiryDate" style="flex: 0 0 150px; width: 150px; padding-left: 10px">Expiry Date</label>
          <div class="flex-fill">
            <div class="input-group">
              <input class="form-control" [value]="vehiclePromotionList[currentIndexForVehicle]?.expiryDate ?? ''" [readonly]="true" />
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex flex-wrap justify-content-center align-items-start">
        <div class="w-100 my-2 d-flex">
          <label class="text-uppercase mb-0 mx-2" for="promotionTerms" style="flex: 0 0 150px; width: 150px">Promotion Terms</label>
          <div class="flex-fill">
            <textarea
              class="form-control"
              [readonly]="!isNewPromotion"
              [value]="vehiclePromotionList[currentIndexForVehicle]?.promotionTerms ?? ''"
              rows="8"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-cancel text-uppercase" (click)="d('cancel click')">Cancel</button>
    <button type="button" class="btn text-uppercase" (click)="addPromotionToVehicle()">Save</button>
  </div>
</ng-template>
